import styled from 'styled-components';
import { darken } from 'polished';
import { tvar } from '@versita/frontend/design-tokens';
import { StyledRadios } from '../../atoms/Radio/Radio.styles';

export const HEADER_HEIGHT = '3.2rem';
export const CELL_HEIGHT = '8rem';

export const StyledTimetableRoot = styled.div`
  flex-grow: 1;
`;

export const StyledTimetable = styled.section`
  width: 100%;
  display: flex;
  position: relative;
`;

export const StyledTimetableHeader = styled.header`
  width: 100%;
  align-items: center;
  display: flex;
  padding-bottom: ${tvar('space.x2')};

  & ${StyledRadios} {
    display: none;
    @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
      display: flex;
    }
  }
`;

export const StyledTimetableHeaderControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;

  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    justify-content: flex-start;
    margin-right: auto;
  }
`;

export const StyledTimetableHeaderLabel = styled.h4`
  text-align: center;
  margin: 0.2rem ${tvar('space.half')} 0;
  min-width: 11em;
  user-select: none;
  font-size: ${tvar('typographies.h3.fontSize')};
`;

export const StyledTimetableHeaderControl = styled.button`
  font-size: 3rem;
  background: transparent;
  cursor: pointer;
  color: ${tvar('colors.brand.primary')};
  border: 0.1rem solid ${tvar('colors.brand.primary')};
  padding: ${tvar('space.x1')};
  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    padding: 0;
    border: 0;
  }
`;

export const StyledTimetableWrapper = styled.div<{ $loading?: boolean }>`
  flex-grow: 1;
  display: flex;
  overflow-x: auto;
  opacity: ${({ $loading }) => ($loading ? 0.6 : 1)};
`;

export const StyledTimetableTimes = styled.div`
  margin-top: ${HEADER_HEIGHT};
  padding-right: ${tvar('space.x1')};
`;

export const StyledTimetableCell = styled.div<{
  $current?: boolean;
  $dayNumber: number;
}>`
  height: ${CELL_HEIGHT};
  border-bottom: 1px solid ${tvar('colors.neutrals.grey3')};
  background: ${({ $current, $dayNumber, theme }) =>
    $current
      ? theme.colors.fill.tertiary
      : $dayNumber > 4
      ? darken(0.02, theme.colors.neutrals.grey2)
      : theme.colors.neutrals.grey2};
`;

export const StyledTimetableTime = styled.div`
  position: relative;
  height: ${CELL_HEIGHT};
  top: calc(${CELL_HEIGHT} - 0.5em);
  line-height: 1;
`;

export const StyledTimetableDay = styled.div`
  min-width: '11.2.rem';
  display: inline-block;
  flex: 1 0 11.2rem;
  border-left: 1px solid ${tvar('colors.neutrals.grey3')};

  &:last-child {
    border-right: 1px solid ${tvar('colors.neutrals.grey3')};
  }
`;

export const StyledTimetableDayLabel = styled.div<{ $current?: boolean }>`
  text-align: center;
  font-size: ${tvar('typographies.large.fontSize')};
  font-weight: ${({ $current }) => ($current ? '600' : 'regular')};
  background: ${tvar('colors.neutrals.grey3')};
  height: ${HEADER_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledTimetableItemsWrapper = styled.div`
  position: relative;
`;
